import { render, staticRenderFns } from "./bgStyle.vue?vue&type=template&id=3415d2c7&scoped=true"
import script from "./bgStyle.vue?vue&type=script&lang=js"
export * from "./bgStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415d2c7",
  null
  
)

export default component.exports